export default __webpack_public_path__ + "idv-app-expired.svg";